<template>
	<div>
		<core-stakeholders-card
			:caseId="caseId"
			:proposalId="proposalId"
			:offerId="offerId"
			:stakeholders="stakeholders"
			stakeholdersOf="offer"
			@stakeholder:added="fetchStakeholders"
			@stakeholder:removed="removeStakeholder"
			variant="no-headline"
			:types="types"
		/>
	</div>
</template>

<script>
import CoreStakeholdersCard from "@/modules/core/components/CoreStakeholdersCard/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { CoreStakeholdersCard },

	props: {
		types: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			stakeholders: []
		}
	},

	computed: {
		caseId() {
			return this.$store.state.caseManagement.caseId
		},
		proposalId() {
			return this.$store.state.caseManagement.proposalId
		},
		offerId() {
			return this.$store.state.caseManagement.offerId
		}
	},

	methods: {
		async fetchStakeholders() {
			const query = gql`
				query offerStakeholders(
					$caseWhere: caseWhere
					$proposalWhere: proposalWhere
					$offerWhere: offerWhere
				) {
					cases(where: $caseWhere) {
						list {
							proposals(where: $proposalWhere) {
								basket(where: $offerWhere) {
									stakeholders {
										id
										type
										entity {
											id
											name
										}
									}
								}
							}
						}
					}
				}
			`

			const res = await api({
				query,
				variables: {
					caseWhere: { id: this.caseId },
					proposalWhere: { id: this.proposalId },
					offerWhere: { id: this.offerId }
				}
			})

			this.stakeholders =
				res?.data?.cases?.list?.[0]?.proposals?.[0]?.basket?.[0]?.stakeholders
		},

		removeStakeholder(stakeholderId) {
			this.stakeholders = this.stakeholders.filter(
				item => item.id !== stakeholderId
			)
		}
	},

	watch: {
		// When store updates, refetch stakeholders
		"$store.state.caseManagement.offerId": {
			handler() {
				console.log("watch fetch")
				this.fetchStakeholders()
			},
			immediate: true
		}
	}
}
</script>
